import { Image } from "@chakra-ui/react"
import LogoStackedSvg from "./logo-stacked.svg"

export const LogoStacked = () => {
  return <Image boxSize="80px" objectFit="contain" src={LogoStackedSvg} alt="ESG logo" mb="10" />
}
